import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class IframeContextService {
	isActive: boolean = false;
}
